<script setup lang="ts">
import { useRoute } from "vue-router";
import { ref, onMounted } from "vue";
import RvApi from "@/rvapi";
const route = useRoute();
const orderId = route.params.id as string;
const loaded = ref(false);
const subject = ref("");

const setFrameContent = (id: string, content: string) => {
  const frame = document.getElementById(id) as HTMLIFrameElement;
  if (frame && frame.contentWindow)
    frame.contentWindow.document.body.innerHTML = content;
};

onMounted(async () => {
  const receipt = await RvApi.getReceiptContent(orderId);
  subject.value = receipt.subject;
  setFrameContent("htmlframe", receipt.html);
  setFrameContent("textframe", `<pre width="400px">${receipt.text}</pre>`);
  loaded.value = true;
});
</script>

<template>
  <h1>Receipt for {{ orderId }}</h1>
  <pn-spinner size="4" v-show="!loaded" />
  <section v-show="loaded">
    <p>
      Below you can view the email that was sent to the customer. There is a
      html version and a text version. 99.9% of customers will have been shown
      the html version, depending on the customer email client settings.
    </p>
    <pre>Email Subject: {{ subject }}</pre>
  </section>
  <section v-show="loaded">
    <iframe
      title="HTML receipt email"
      id="htmlframe"
      src="javascript:void(0);"
    ></iframe>
  </section>
  <section v-show="loaded">
    <iframe
      title="text receipt email"
      id="textframe"
      src="javascript:void(0);"
    ></iframe>
  </section>
</template>

<style lang="scss" scoped>
iframe {
  width: 70vw;
  height: 500px;
}
</style>
